import { useMemo } from 'react';

import getFullImageUrl, {
  getAbsoluteUrl,
} from '@services/images/getFullImageUrl';
import { URLS } from '@services/images/constants';
import useScreenWidthImage from './useScreenWidthImage';

function useProductConfigHeaderImage({ image, withOverlay, isQC }) {
  const imageWidth = useScreenWidthImage();
  const fnToUse = isQC ? getAbsoluteUrl : getFullImageUrl;

  const payload = {
    image,
    width: withOverlay ? 150 : imageWidth,
    height: withOverlay ? 150 : null,
  };

  if (!isQC) {
    payload.url = URLS.PRODUCT;
  }

  const src = useMemo(() => (imageWidth ? fnToUse({ ...payload }) : ''), [
    fnToUse,
    imageWidth,
    payload,
  ]);

  return src;
}

export default useProductConfigHeaderImage;
